import styled from 'styled-components';

export const Container = styled.div`
  iframe {
    width: 100%;
    height: 420px;
    border: unset;
  }
`;
